















































































import { Component, Mixins } from 'vue-property-decorator';
import IsMobileMixin from '@/mixins/vue/IsMobileMixin';
import moment from 'moment';

@Component
export default class ProfileDetails extends Mixins(IsMobileMixin) {
    get theUser() {
        return this.$store.getters.getUser;
    }

    get memberSince() {
        return moment(this.theUser.created_at).format('MMMM Do, YYYY');
    }
}
